var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H512.5V512H0.5V0Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0V32L161.5 128L256.5 221.5V256H223L127.5 162L34.5 256H0.5V222L93.5 128.5L0.5 37V0H31.5L127.5 94L220.5 0H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5 162L98 179L21.5 256H0.5V254.5L92.5 162ZM154.5 156L181.5 160L256.5 233.5V256L154.5 156ZM256.5 0L160.5 98L158.5 76L233.5 0H256.5ZM0.5 0.5L97 95L67.5 91L0.5 24.5V0.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 0V256H168.5V0H88.5ZM0.5 88V168H256.5V88H0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 104V152H256.5V104H0.5ZM104.5 0V256H152.5V0H104.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5 402.8L156.7 408.2L161.3 454.1L128.5 421.7L95.5001 453.9L100.4 408L54.6001 402.2L93.5001 377.4L69.5001 338L113.1 353L128.9 309.6L144.4 353.1L188.1 338.4L163.8 377.6L202.6 402.7L202.5 402.8ZM425.2 410.8L404.7 413.4L406.9 433.9L392.1 419.5L377.4 434L379.4 413.5L358.9 411.1L376.2 399.9L365.3 382.4L384.9 388.9L391.8 369.4L398.9 388.8L418.4 382.1L407.7 399.7L425.2 410.8ZM415.5 293.6L418.2 280.6L408.4 271.6L421.6 270.1L427.1 258L432.6 270.1L445.8 271.6L436 280.6L438.7 293.6L427.1 287L415.5 293.6ZM331.4 233.6L311.1 235.8L312.9 256.1L298.5 241.6L283.7 255.7L286.1 235.4L265.9 232.7L283.2 221.9L272.7 204.4L292 211.2L299.2 192.1L305.9 211.4L325.3 205.1L314.4 222.4L331.4 233.6ZM507.2 200.8L486.3 203.5L488.6 224.4L473.5 209.7L458.5 224.5L460.6 203.5L439.7 201.1L457.4 189.6L446.3 171.7L466.3 178.4L473.3 158.6L480.5 178.4L500.4 171.5L489.4 189.5L507.2 200.8ZM425.1 117.3L404.4 119.6L406.3 140.4L391.6 125.6L376.5 140L378.9 119.3L358.2 116.5L375.9 105.5L365.2 87.6L384.9 94.5L392.2 75L399 94.7L418.8 88.2L407.7 105.8L425.1 117.3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_1339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.771182921966cdef171ebeb420ad6793.svg";
export { ForwardRef as ReactComponent };